export const CLEAR_INVESTOR_STATE = 'CLEAR_INVESTOR_STATE';

export const GET_INVESTOR_REQUEST = 'GET_INVESTOR_REQUEST';
export const GET_INVESTOR_SUCCESS = 'GET_INVESTOR_SUCCESS';
export const GET_INVESTOR_ERROR = 'GET_INVESTOR_ERROR';
export const CLEAR_INVESTOR_LIST = 'CLEAR_INVESTOR_LIST';
